import React from "react";

const QuotaExceeded = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 0 41 41"
    >
      <g id="db79" transform="translate(-154.01 -154.008)">
        <path
          id="Path_1752"
          data-name="Path 1752"
          d="M174.51,194.325a19.817,19.817,0,1,1,19.817-19.817A19.817,19.817,0,0,1,174.51,194.325Zm0,.683a20.5,20.5,0,1,0-20.5-20.5A20.5,20.5,0,0,0,174.51,195.008Z"
          fill="#404040"
        />
        <path
          id="Path_1753"
          data-name="Path 1753"
          d="M201.377,189.078v-5.467a17.767,17.767,0,1,0,10.443,32.141l-3.213-4.423a12.3,12.3,0,1,1-7.23-22.252Z"
          transform="translate(-26.867 -26.869)"
          fill="#404040"
        />
      </g>
    </svg>
  );
};

export default QuotaExceeded;
